import { render, staticRenderFns } from "./ModalCommittee.vue?vue&type=template&id=6b3b1574&scoped=true"
import script from "./ModalCommittee.vue?vue&type=script&lang=js"
export * from "./ModalCommittee.vue?vue&type=script&lang=js"
import style0 from "./ModalCommittee.vue?vue&type=style&index=0&id=6b3b1574&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3b1574",
  null
  
)

export default component.exports